import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Manages a Bootstrap pickup modal:
//   - focuses the first input when the modal opens (shown.bs.modal)
//   - cleans up the Bootstrap backdrop/body state when Turbo Stream
//     removes the element from the DOM after a successful pickup
export default class extends Controller {
  connect() {
    this._modal = Modal.getOrCreateInstance(this.element)
    this.element.addEventListener("shown.bs.modal", this._focusInput)
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.modal", this._focusInput)

    if (document.body.classList.contains("modal-open")) {
      document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
      document.body.classList.remove("modal-open")
      document.body.style.removeProperty("overflow")
      document.body.style.removeProperty("padding-right")
    }
  }

  _focusInput = () => {
    const inputs = this.element.querySelectorAll("input:not([type=hidden]):not([disabled])")
    const empty = Array.from(inputs).find((el) => !el.value?.trim())
    const target = empty || inputs[0]
    if (target) target.focus()
  }
}
